import { useOptimisticMutation } from "../hooks/useOptimisticMutation";
import { upsertBettingMarketsSuspensions } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import type {
  UpsertBettingMarketSuspensionsParams,
  BettingMarketSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingMarket";

export const useUpsertBettingMarketsSuspensions = (targetUsername?: string) => {
  const queryKey = [BettingMarketsQueryKeys.BettingMarketsSuspensions, targetUsername];

  return useOptimisticMutation<
    UpsertBettingMarketSuspensionsParams,
    BettingMarketSuspensionsEditorResponse
  >({
    queryKey,
    mutationFn: upsertBettingMarketsSuspensions,
    optimisticUpdate: (variable, oldData) => {
      if (!oldData) return oldData;

      const newSuspensions = { ...oldData.suspensions };
      for (const s of variable.suspensions) {
        newSuspensions[s.bettingMarketId] = { id: s.bettingMarketId, active: s.active };
      }

      return { ...oldData, suspensions: newSuspensions };
    },
    updateOptions: { exactQueryKey: true },
  });
};
